import { endpoints } from 'zylo_schema/contracts/endpoints';
import { mockRequestHandler } from '..';
import { postsStore } from './postsStore';
import { usersStore } from '../usersMocks/usersStore';

export const postsHandlers: mockRequestHandler[] = [
  {
    endpoint: '/posts',
    method: 'get',
    response: () => {
      const response: endpoints['get_posts']['responses'] = {
        status: 200,
        data: {
          posts: postsStore,
        },
      };
      return response;
    },
  },
  {
    endpoint: '/post',
    method: 'get',
    response: ({ query }) => {
      const { post_id } = query;
      const post = postsStore.find(({ id }) => id.toString() === post_id);
      const response: endpoints['get_post']['responses'] = post
        ? {
            status: 200,
            data: post,
          }
        : {
            status: 404,
            data: { message: 'Post not found' },
          };
      return response;
    },
  },
  {
    endpoint: '/user-posts',
    method: 'get',
    response: ({ query }) => {
      const { user_id } = query;
      const posts = postsStore.filter(p => p.user_id.toString() === user_id);
      const response: endpoints['get_user_posts']['responses'] = {
        status: 200,
        data: {
          posts,
        },
      };
      return response;
    },
  },
  {
    endpoint: '/post',
    method: 'post',
    response: ({ payload }) => {
      const post = payload as endpoints['create_post']['params'];

      // add post to posts store
      postsStore.push(post);
      // add post id to user in usersstore
      const userIndex = usersStore.findIndex(({ id }) => id === post.user_id);
      if (userIndex >= 0) {
        const user = usersStore[userIndex];
        usersStore[userIndex] = { ...user, posts: [...user.posts, post.id] };
      }

      const response: endpoints['create_post']['responses'] = {
        status: 200,
        data: { post_id: payload.id },
      };
      return response;
    },
  },
];
